module.exports = __webpack_public_path__ + "static/media/tPanel.7cb752bc.png";